import getProgressCoordinates from "./get-progress-coordinates";
import getProgressTime from "./get-progress-time";

/**
 *
 * @param {StepProps | PropertyValueProps} step
 * @param {Number} limited
 * @param {Boolean} enter
 * @param {Boolean} coordinates
 * @param {Boolean} spring
 * @returns {Number}
 */
const getProgress = (step, limited, enter, coordinates, spring) => {
  if (coordinates) {
    return getProgressCoordinates(step, limited);
  } else {
    return getProgressTime(step, limited, enter, spring);
  }
};

export default getProgress;
